import { useModalStore } from './Modal';
import { useBaseStore } from './Base';
import { useGameStore } from './Game';

export const useModal = useModalStore;
export const useBase = useBaseStore;
export const useGame = useGameStore;
